import React, { useState } from 'react'
import { Formik } from 'formik'
import { pathOr } from 'ramda'
import Form, {
  Grid,
  Row,
  Col,
  Label,
  Field,
  ButtonRow,
  Button,
  ErrorMessage,
  MaskedInput
} from '../../../components/Form'
import Modal from '../../../components/Modal'
import MapAddressSelector from './MapAddressSelector'
import { validationSchema, phoneNumberMask } from './utils'

const AddressModal = props => {
  const {
    isOpen,
    onRequestClose,
    createAddress,
    updateAddress,
    initialValues,
    hasNoAddresses
  } = props

  const [addressError, setAddressError] = useState('')

  const mapItemWithMap = selection => {
    const {
      components: {
        street_number,
        route,
        administrative_area_level_1,
        administrative_area_level_2,
        postal_code
      }
    } = selection

    return {
      street: street_number + ' ' + route,
      city: administrative_area_level_2 || '',
      state: administrative_area_level_1 || '',
      zipcode: postal_code || ''
    }
  }

  const onClose = () => {
    setAddressError('')
    onRequestClose()
  }

  const onUpdateAddress = values => {
    const addressId = pathOr('', ['id'], initialValues)
    return updateAddress({ ...values, id: addressId })
  }

  const onSubmit = (values, { setSubmitting }) => {
    const saveAddress = initialValues ? onUpdateAddress : createAddress

    saveAddress(values).then(({ success, error }) => {
      setSubmitting(false)
      if (success) {
        onClose()
      } else {
        setAddressError(error)
      }
    })
  }

  const isEditingDefaultAddress = pathOr(false, ['isActive'], initialValues)

  return (
    <Modal
      title={initialValues ? 'Update Address' : 'Add New Address'}
      isOpen={isOpen}
      onRequestClose={onClose}
      size="lg">
      <Formik
        isInitialValid={false}
        initialValues={{
          city: pathOr('', ['city'], initialValues),
          zipcode: pathOr('', ['postcode'], initialValues),
          street: pathOr('', ['street'], initialValues),
          floor: pathOr('', ['floor'], initialValues),
          state: pathOr('', ['region'], initialValues),
          is_default:
            hasNoAddresses || pathOr(false, ['isActive'], initialValues),
          phone: pathOr('', ['telephone'], initialValues)
        }}
        validationSchema={validationSchema}
        onSubmit={onSubmit}>
        {({
          isSubmitting,
          values,
          setFieldValue,
          setValues,
          setTouched,
          isValid,
          handleChange,
          handleBlur
        }) => {
          const toggleDefaultAddress = () => {
            setFieldValue('is_default', !values.is_default, true)
          }

          return (
            <Form>
              <Grid>
                <Col>
                  <Label>Street</Label>
                  <MapAddressSelector
                    handleChange={street => {
                      setFieldValue('street', street)
                      setTouched({ street: true })
                    }}
                    handleSelection={selection => {
                      const newValues = mapItemWithMap(selection)
                      setValues({ ...values, ...newValues })
                      setTouched({
                        street: true,
                        city: true,
                        state: true,
                        zipcode: true
                      })
                    }}
                    name="street"
                    value={values.street}
                  />
                  <ErrorMessage name="street" component="div" />
                </Col>
                <Col>
                  <Label>Apt / Office / Suite</Label>
                  <Field type="text" name="floor" />
                  <ErrorMessage name="floor" component="div" />
                </Col>

                <Col>
                  <Label>State</Label>
                  <Field type="text" name="state" />
                  <ErrorMessage name="state" component="div" />
                </Col>
                <Col>
                  <Label>City</Label>
                  <Field type="text" name="city" />
                  <ErrorMessage name="city" component="div" />
                </Col>

                <Col>
                  <Label>Zip Code</Label>
                  <Field type="text" name="zipcode" />
                  <ErrorMessage name="zipcode" component="div" />
                </Col>

                <Col>
                  <Label>Phone</Label>
                  <MaskedInput
                    name="phone"
                    placeholder="(___) ___-____"
                    value={values.phone}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    mask={phoneNumberMask}
                  />
                  <ErrorMessage name="phone" component="div" />
                </Col>
              </Grid>

              {!isEditingDefaultAddress && !hasNoAddresses && (
                <Row>
                  <Col>
                    <Field
                      type="checkbox"
                      name="is_default"
                      checked={values.is_default}
                      onClick={toggleDefaultAddress}
                      label="Set as my default address"
                    />
                  </Col>
                </Row>
              )}

              {!!addressError && (
                <Row>
                  <Col>
                    <div className="cookunity__form_error_message">
                      {addressError}
                    </div>
                  </Col>
                </Row>
              )}

              <ButtonRow>
                <Button
                  dark
                  large
                  type="submit"
                  loading={isSubmitting}
                  disabled={!isValid}>
                  {initialValues ? 'Update Address' : 'Create Address'}
                </Button>
                <Button type="button" transparent large onClick={onClose}>
                  Cancel
                </Button>
              </ButtonRow>
            </Form>
          )
        }}
      </Formik>
    </Modal>
  )
}

export default AddressModal



// WEBPACK FOOTER //
// ./src/modules/Checkout/DeliveryDetails/AddressModal.jsx